__turbopack_context__.v({
  "donate_description": "sjJ0Tq_donate_description",
  "donate_text": "sjJ0Tq_donate_text",
  "donation_text_non_passport_member": "sjJ0Tq_donation_text_non_passport_member",
  "donation_text_passport_member": "sjJ0Tq_donation_text_passport_member",
  "member_lookup": "sjJ0Tq_member_lookup",
  "passport_learn_more__inner": "sjJ0Tq_passport_learn_more__inner",
  "passport_learn_more_hero": "sjJ0Tq_passport_learn_more_hero",
  "passport_learn_more_hero_content": "sjJ0Tq_passport_learn_more_hero_content",
  "passport_learn_more_hero_donate_blurb": "sjJ0Tq_passport_learn_more_hero_donate_blurb",
  "passport_learn_more_hero_title": "sjJ0Tq_passport_learn_more_hero_title",
});
